import React, { useEffect, useState } from 'react';
import { ToastContainer } from 'react-toastify';
import CompanyName from '../../../commonComponents/CompanyName';
import { CompanyNameType } from '../../../../static/types/commonTypes/companyNameType';
import { StatusSignatureType } from '../../../../static/types/commonTypes/statusSignatureType';
import StatusSignature from '../../../commonComponents/StatusSignature';
import TheSociety from '../../../commonComponents/TheSociety';
import { HeadOfficeAddressType } from '../../../../static/types/commonTypes/headOfficeAddressType';
import HeadOfficeAddress from '../../../commonComponents/HeadOfficeAddress';
import { Clause } from '../../../../static/types/clauseTypes/clauseType';
import { clauseinitial } from '../../../../static/types/clauseTypes/clauseInitialState';
import ComponentsClause from '../crearionSASU/componentsClause';
import { getCityWithPreposition } from '../../../../utils/functions/getCityWithPreposition';
import { ManagerType } from '../../../../static/types/commonTypes/managerType';
import ManagerList from '../../../commonComponents/ManagerList';
import useAppContext from '../../../../hooks/useAppContext';
import { AppContextType } from '../../../../context/AppContext';
import { SlArrowLeft, SlArrowRight } from "react-icons/sl";
import { FaUpload } from 'react-icons/fa';
import { GoArrowRight } from 'react-icons/go';
import { formatObjectText } from '../../../../utils/functions/formatObjectText';

interface AnnonceProps {
    txtAnnonce: string;
    updateActiveIndex: (index: number) => void;
    updateTxtAnnonce: (newTxt: string) => void;
    updateDenomination: (newTxt: string) => void;
    societyType: string | string[];
    societeSelected: string;
    updatesocieteSelected: (newTxt: string) => void;

}
const CreationSCI: React.FC<AnnonceProps> = ({
    txtAnnonce,
    updateTxtAnnonce,
    updateActiveIndex,
    updateDenomination,
    societyType,
}) => {

    const {
        companyName, setCompanyName,
        companyNameValidity, setCompanyNameValidity,
        companyNameChecked, setCompanyNameChecked,

        statusSignature, setStatusSignature,
        statusSignatureValidity, setStatusSignatureValidity,
        statusSignatureChecked, setStatusSignatureChecked,

        theSociety, setTheSociety,
        theSocietyValidity, setTheSocietyValidity,
        theSocietyChecked, setTheSocietyChecked,

        headOfficeAddress, setHeadOfficeAddress,
        headOfficeAddressValidity, setHeadOfficeAddressValidity,
        headOfficeAddressChecked, setHeadOfficeAddressChecked,

        managers, setManagers,
        managersValidity, setManagersValidity,
        managersChecked, setManagersChecked,

        clause, setClause,
        
        lastTab, setLastTab,

    } = useAppContext() as AppContextType


    const societyTypeOptions = Array.isArray(societyType) ? societyType : [societyType];
    const [activeTab, setActiveTab] = useState<string>('companyName');
    const [visitedTabs, setVisitedTabs] = useState(['companyName']);
    const [submissive, setSubmissive] = useState<boolean>(false)

    const goToSupportPresse = () => {
        updateActiveIndex(2);
    }

    const switchTab = (tab: string) => {
        setActiveTab(tab);
    };

    const handleSubmit = (e: React.FormEvent) => {

        e.preventDefault();

        if (validate()) {

            const natureActText = statusSignature.actNature === "acte sous seing privé" ? 'acte SSP' : 'acte authentique'

            const tempText = `Par ${natureActText} du ${statusSignature.actDate},  il a été constitué une ${theSociety.legalForm} ayant les caractéristiques suivantes :
Dénomination : ${companyName.companyName}, ${theSociety.acronym ? `
Sigle: ${theSociety.acronym}` : ``},
Objet social : ${theSociety.object},
Siège social : ${headOfficeAddress.address} ${headOfficeAddress.additionalAddress ?? ""} ${headOfficeAddress.postalCode} ${headOfficeAddress.city},
Capital : ${theSociety.capital} €,
Durée : ${theSociety.duration > 1 ? `${theSociety.duration} ans` : `${theSociety.duration} an`},
${managers.map((manager: ManagerType, index: number) => {
                if (manager.person === "Personne morale") {
                    return ` ${manager.entityDetails.companyName}, ${manager.entityDetails.legalForm} au capital de ${manager.entityDetails.capital} €, ayant son siège social ${manager.entityDetails.address} ${manager.entityDetails.additionalAddress ?? ""} ${manager.entityDetails.postalCode} ${manager.entityDetails.city}, ${manager.entityDetails.rcs} RCS ${getCityWithPreposition(manager.entityDetails.registrationOffice)},`
                }
                else if (manager.person === "Personne physique") {
                    return ` ${manager.personDetails.civility === 'Monsieur' ? 'M.' : 'Mme'} ${manager.personDetails.lastName} ${manager.personDetails.firstName}, demeurant ${manager.personDetails.address} ${manager.personDetails.additionalAddress ?? ""} ${manager.personDetails.postalCode} ${manager.personDetails.city},`
                }
            })} ${clause.clause ?
                `Clause d'agrément : ${clause.clause},` : ''}
Immatriculation au RCS ${getCityWithPreposition(headOfficeAddress.registrationOffice)}.
`


            const formattedText = formatObjectText(tempText);
            updateTxtAnnonce(formattedText);
            updateDenomination(companyName.companyName)
        }
    };

    // Submit Form
    const validate = () => {
        if (!companyNameValidity) {
            setActiveTab('companyName')
        }
        else if (!statusSignatureValidity) {
            setActiveTab('statusSignature')
        }
        else if (!theSocietyValidity) {
            setActiveTab('theSociety')
        }
        else if (!headOfficeAddressValidity) {
            setActiveTab('headOfficeAddress')
        }
        else if (!managersValidity) {
            setActiveTab('managment')
        }
        return companyNameValidity && statusSignatureValidity && theSocietyValidity && headOfficeAddressValidity && managersValidity
    };

    const handleNext = () => {

        // Formatage de theSociety (Objet Social)
        const formattedSociety = {
            ...theSociety,
            object: formatObjectText(theSociety.object)
        };

        // Utilisez formattedSociety pour mettre à jour les données
        setTheSociety(formattedSociety);

        if (activeTab === "companyName") {
            setCompanyNameChecked(true)
            if (companyNameValidity) {
                switchTab(getNextTab("companyName"));
            }
        } else if (activeTab === "statusSignature") {
            setStatusSignatureChecked(true)
            if (statusSignatureValidity) {
                switchTab(getNextTab("statusSignature"));
            }
        } else if (activeTab === "theSociety") {
            setTheSocietyChecked(true)
            if (theSocietyValidity) {
                switchTab(getNextTab("theSociety"));
            }
        } else if (activeTab === "headOfficeAddress") {
            setHeadOfficeAddressChecked(true)
            if (headOfficeAddressValidity) {
                switchTab(getNextTab("headOfficeAddress"));
            }
        } else if (activeTab === 'managment') {
            setManagersChecked(true)
            if (managersValidity) {
                switchTab(getNextTab('clause'))
            }
        } else if (activeTab === 'clause') {
            setSubmissive(true)
        }
    };

    const handlePrevious = () => {
        switchTab(getPreviousTab(activeTab));
        setSubmissive(false);
    }
    
    useEffect(() => {
        // Si on vient d'un brouillon, restaurer l'onglet actif
        if ( lastTab ) {
            setActiveTab(lastTab);
            // Ajouter tous les onglets précédents comme visités
            const tabOrder = ['companyName', 'statusSignature', 'theSociety', 'headOfficeAddress', 'managment'];
            const currentTabIndex = tabOrder.indexOf(lastTab);
            const visitedTabsArray = tabOrder.slice(0, currentTabIndex + 1);
            setVisitedTabs(visitedTabsArray);
        }
    }, []);

    
    useEffect(() => {
        setLastTab(activeTab);
    }, [activeTab]);
    
    const getNextTab = (currentTab: string) => {
        if (currentTab === "companyName") return "statusSignature";
        else if (currentTab === "statusSignature") return "theSociety";
        else if (currentTab === "theSociety") return "headOfficeAddress";
        else if (currentTab === "headOfficeAddress") return "managment";
        else return currentTab;
    };

    const getPreviousTab = (currentTab: string) => {
        if (currentTab === "clause") return "managment";
        else if (currentTab === "managment") return "headOfficeAddress";
        else if (currentTab === "headOfficeAddress") return "theSociety";
        else if (currentTab === "theSociety") return "statusSignature";
        else if (currentTab === "statusSignature") return "companyName";
        else return currentTab;
    };

    // dénomination
    const updateCompanyNameValidity = (isValid: boolean) => setCompanyNameValidity(isValid);
    const updateCompanyName = (data: Partial<CompanyNameType>) => setCompanyName({ ...companyName, ...data });

    // signature des statuts
    const updateStatusSignatureValidity = (isValid: boolean) => setStatusSignatureValidity(isValid);
    const updateStatusSignature = (data: Partial<StatusSignatureType>) => setStatusSignature({ ...statusSignature, ...data });

    // The Society
    const updateTheSocietyValidity = (isValid: boolean) => setTheSocietyValidity(isValid);

    // Head Office Adress
    const updateHeadOfficeAddressValidity = (isValid: boolean) => setHeadOfficeAddressValidity(isValid);
    const updateHeadOfficeAddress = (data: Partial<HeadOfficeAddressType>) => setHeadOfficeAddress({ ...headOfficeAddress, ...data });


    //Clause Agreement
    const updateClause = (data: Partial<Clause>) => setClause((prevClause) => ({ ...prevClause, ...data }));
    const tabs = [
  { key: "companyName", label: "Raison Sociale" },
  { key: "statusSignature", label: "Signature des Status" },
  { key: "theSociety", label: "La Société" },
  { key: "headOfficeAddress", label: "Adresse du Siège Social" },
  { key: "managment", label: "La Gérance" },
  { key: "clause", label: "Clause d'agréement" },
];

    return (
        <>
                <div className="container my-3">
                <ul className="nav nav-underline">
                    {tabs
                    .filter((t) => t.key === activeTab) 
                    .map((t) => (
                        <li className="nav-item" key={t.key}>
                        <a
                            href={`#${t.key}`}
                            className={`nav-link active`} 
                        >
                            {t.label}
                        </a>
                        </li>
                    ))}
                </ul>
                </div>

            <ToastContainer />

            <form onSubmit={handleSubmit}>
                {
                    activeTab === 'companyName' &&
                    <CompanyName
                        changeCompanyName={updateCompanyName}
                        companyName={companyName}
                        checked={companyNameChecked}
                        onValidationChange={updateCompanyNameValidity}
                    />
                }
                {
                    activeTab === 'statusSignature' &&
                    <StatusSignature
                        changeStatusSignature={updateStatusSignature}
                        checked={statusSignatureChecked}
                        onValidationChange={updateStatusSignatureValidity}
                        statusSignature={statusSignature}
                    />
                }
                {
                    activeTab === 'theSociety' &&
                    <TheSociety
                        checked={theSocietyChecked}
                        companyName={companyName}
                        setTheSociety={setTheSociety}
                        theSociety={theSociety}
                        updateCompanyName={updateCompanyName}
                        updateCompanyNameValidity={updateCompanyNameValidity}
                        updateTheSocietyValidity={updateTheSocietyValidity}
                        societyType={[
                            "Société civile immobilière",
                            "Société civile immobilière à capital variable",
                            "Société civile immobilière de construction vente"
                        ]}
                    />
                }
                {
                    activeTab === 'headOfficeAddress' &&
                    <HeadOfficeAddress
                        changeHeadOfficeAddress={updateHeadOfficeAddress}
                        checked={headOfficeAddressChecked}
                        headOfficeAddress={headOfficeAddress}
                        onValidationChange={updateHeadOfficeAddressValidity}
                    />
                }


                {
                    activeTab === 'managment' &&
                    <ManagerList
                        labelItem='Gérance'
                        checked={managersChecked}
                        societyTypeOptions={societyTypeOptions}
                        managers={managers}
                        setManagers={setManagers}
                        addButtonText="Ajouter un gérant"
                        removeButtonText="Supprimer le dernier gérant"
                        setManagersValidity={(isValid: boolean) => setManagersValidity(isValid)}
                        draftFieldName = 'managers'
                    />
                }

                {
                    activeTab === 'clause' &&
                    <ComponentsClause
                        clause={clause}
                        changeClause={updateClause}
                    />
                }
                {
                    activeTab === 'clause' &&
                    submissive && (
                        <div className="mt-4">
                            <h4>Texte de l'annonce:</h4>
                            <textarea
                                className="form-control"
                                rows={5}
                                value={txtAnnonce}
                                disabled
                            />
                        </div>
                    )}
                <div className="button-container">
                    <div className="d-flex gap-2">
                        {
                            activeTab !== 'companyName' && (
                                <button
                                    color="#F4A261"
                                    className="btn-add"
                                    type="button"
                                    onClick={handlePrevious}>
                                    <SlArrowLeft className="icon" style={{ marginRight: '10px', fontSize: '20px' }} />
                                    Modifier mon annonce
                                </button>
                            )}

                        {
                            activeTab !== 'clause' && (
                                <button
                                    color="#F4A261"
                                    className="btn-add"
                                    type="button"
                                    onClick={handleNext}>
                                    Suivant
                                    <SlArrowRight className="icon" style={{ marginLeft: '10px', fontSize: '20px' }} />
                                </button>
                            )}

                        {
                            activeTab === 'clause' && (
                                <button type="submit"
                                    onClick={handleNext}>
                                    Mettre à jour mon annonce
                                    <FaUpload className="icon" style={{ marginLeft: '15px', fontSize: '20px' }} />
                                </button>
                            )}

                        {
                            submissive && activeTab === 'clause' && (
                                <button color="#F4A261"
                                    className="btn-add"
                                    type="button"
                                    onClick={goToSupportPresse} >
                                    Sélection du support
                                    <GoArrowRight className="icon" style={{ marginLeft: '10px', fontSize: '20px' }} />
                                </button>
                            )}
                    </div>
                </div>
            </form>
        </>
    );
};

export default CreationSCI;